import { useSelector } from 'react-redux';

import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { FIRST_PAYMENTS_PERIOD } from '../../constants';
import type { FlexBuyPaymentFigureField } from '../types';
import { replaceConstantWithTerm } from '../utils';

export const useFirstPaymentPeriodField = (): FlexBuyPaymentFigureField => {
    const flexBuyPayment = useSelector(offerReduxSelectors.getCurrentFlexBuyPayments);

    const firstPaymentPeriodValue = flexBuyPayment?.firstTermPaymentDetail?.paymentAmount || 0;
    const firstTerm = flexBuyPayment?.firstTermPaymentDetail?.term;

    return {
        label: replaceConstantWithTerm({ constantLabel: FIRST_PAYMENTS_PERIOD, currentTerm: `${firstTerm || ''}` }),
        value: formatDollarsAndCents(firstPaymentPeriodValue)
    };
};
